export default "__VITE_ASSET__F3lFPEC4__"